import type { SVGProps } from "react";
import { Icon, type IconProps } from "../Icon";
const InternalSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="m10.885 21.938.743-6.625-6.625-.744-.632 5.632a1 1 0 0 0 .883 1.105l2.294.257zM8.688 11.628l-6.625-.743 2.94 3.684 6.626.744z"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="m10.885 21.938 5.632.632a1 1 0 0 0 1.105-.883l.632-5.631-6.625-.744z"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="m21.938 13.115-6.625-.743-3.685 2.94 6.625.744z"
    />
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M12.074 11.338s.818-7.288-3.157-7.734c-3.313-.372-3.833 4.266.805 4.786M16.353 3.097c4.638.52 3.969 6.482-1.994 5.813"
      style={{
        stroke: "var(--icon-accent,#E47B53)",
      }}
    />
  </svg>
);
export const EmptyBoxIcon = (props: IconProps) => (
  <Icon {...props} Icon={InternalSvg} />
);
